import config from "../config"

export const PLAY_STORE_APP_PAGE_URL =
  config.ANDROID_APP_ID &&
  `http://play.google.com/store/apps/details?id=${config.ANDROID_APP_ID}`

export const APP_STORE_APP_PAGE_URL =
  config.APPLE_ID && `https://apps.apple.com/app/id${config.APPLE_ID}`
